import React from 'react';
import {HashRouter} from 'react-router-dom';
import AssignQuotePopup from '../../bvcomponents/popups/assignQuotePopup/assignQuotePopup';
import MessageBox from '../../bvcomponents/popups/messageBox';
import LoaderView from '../../bvcomponents/ui/loaderView';
import {buildFatalErrorRecoveryMessageBoxState} from './errorRecoveryPopup';
import {reportFatalError} from './errorReporter';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    reportFatalError('react-error-boundary', error, {
      componentStack: errorInfo && errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Fragment>
          <MessageBox state={buildFatalErrorRecoveryMessageBoxState()}/>
          <HashRouter>
            <React.Fragment>
              <AssignQuotePopup/>
              <LoaderView/>
            </React.Fragment>
          </HashRouter>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}
